export class FetFormate {
    fetDate: Date
    table: Array<FetFormatetable>
    consultant: string
    embryologist: string;
    imageUrl: string;
}
export class FetFormatetable {
    noOfEnbryoThawed: string
    recovered: string
    overNightCulture: string
    embryoStatus: string
    discarded: string
    remaining: string
    catheterUsed:string
}
export class ProductTable {
    medicineName: string;
    frequency: string;
    route: string;
    duration: string;
    dosage: string;
    remark: string;

}